var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loaderContainer"}},[_c('sui-dimmer',{attrs:{"active":"","inverted":""}},[_c('sui-loader',{attrs:{"content":_vm.showMessage}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }